// @flow
import env from '../../environment';
import {getCreator, postCreator, putCreator} from '../../http';

import type {TaxInvoiceStateType, OrderTaxInvoiceData} from '../../entities';

export const endpoints = Object.freeze({
  GET_PROVIDERS: `${env.baseApiUrl}/im/admin/tax-invoice/provider`,
  GET_INVOICE_BY_PROVIDER: `${env.baseApiUrl}/im/admin/tax-invoice/tax-invoice-types`,

  GET_STORE_PROVIDERS: `${env.baseApiUrl}/im/admin/tax-invoice/store/providers`,
  CREATE_STORE_PROVIDERS: `${env.baseApiUrl}/im/admin/tax-invoice/store/provider`,

  GET_INVOICE_TYPES: `${env.baseApiUrl}/im/admin/tax-invoice/type`,

  GET_ORDER_TAX_INVOICE_LIST: `${env.baseApiUrl}/im/admin/tax-invoice/`,
  GET_ORDER_TAX_INVOICE_LIST_BY_IDS: `${env.baseApiUrl}/im/admin/tax-invoice/orders`,
  GET_ORDER_TAX_INVOICE_INFORMATION_LIST_BY_IDS: `${env.baseApiUrl}/im/admin/tax-invoice/orders/information`,

  GENERATE_ORDER_TAX_INVOICE: `${env.baseApiUrl}/im/admin/tax-invoice/order/:orderId/generate`,

  GET_STORE_TAX_INVOICE_TYPE: `${env.baseApiUrl}/im/admin/tax-invoice/store/type`,

  GET_ORDER_TAX_INVOICE_INFORMATION: `${env.baseApiUrl}/im/admin/tax-invoice/order/:orderId/information/`,
  EDIT_ORDER_TAX_INVOICE_DATA: `${env.baseApiUrl}/im/admin/tax-invoice/order/:orderId/information`,

  CANCEL_ORDER_TAX_INVOICE: `${env.baseApiUrl}/im/admin/tax-invoice/:orderTaxInvoiceId/cancel`,

  GET_TAX_INVOICE_SETTING: `${env.baseApiUrl}/im/admin/tax-invoice/setting`,
  SET_TAX_INVOICE_SETTING: `${env.baseApiUrl}/im/admin/tax-invoice/setting`,

  EXPORT_TAX_INVOICE_DATA: `${env.baseApiUrl}/im/admin/tax-invoice/export`,
});

export type OrderTaxInvoice = {
  amount: string,
  apiResult: string,
  country: {
    code: string,
    code3: string,
    id: string,
    name: string,
    phonePrefix: string,
    type: string,
  },
  createdAt: number,
  id: string,
  issueDate?: number,
  orderId: string,
  pdfUrl: string,
  relatedTaxInvoiceId: string,
  state: TaxInvoiceStateType,
  storeId: string,
  taxInvoiceProvider: {
    country: {
      code: string,
      code3: string,
      id: string,
      name: string,
      phonePrefix: string,
      type: string,
    },
    currency: {
      code: string,
      id: string,
      name: string,
      symbol: string,
      type: string,
    },
    id: string,
    label: string,
    name: string,
    type: string,
  },
  taxInvoiceProviderId: string,
  taxInvoiceType: {
    country: {
      code: string,
      code3: string,
      id: string,
      name: string,
      phonePrefix: string,
      type: string,
    },
    id: string,
    label: string,
    name: string,
    type: string,
  },
  taxInvoiceTypeId: string,
  taxReceiverCode: string,
  taxReceiverName: string,
  taxTransmitterCode: string,
  taxTransmitterName: string,
  type: string,
  updatedAt: number,
  formattedExternalReferenceId?: string,
};

export type GenerateOrderTaxInvoiceResponse = OrderTaxInvoiceData;

export type EditOrderTaxInvoiceInformationResponse = {
  address: string,
  admin1: number,
  admin2: number,
  admin3: number,
  country: {
    code: string,
    code3: string,
    id: string,
    name: string,
    phonePrefix: string,
    type: string,
  },
  createdAt: number,
  id: string,
  orderId: string,
  taxInvoiceType: {
    country: {
      code: string,
      code3: string,
      id: string,
      name: string,
      phonePrefix: string,
      type: string,
    },
    id: string,
    label: string,
    name: string,
    type: string,
  },
  taxReceiverCode: string,
  taxReceiverName: string,
  type: string,
  updatedAt: number,
};

export const getProvidersApi = getCreator(endpoints.GET_PROVIDERS);

export const getInvoiceByProviderApi = getCreator(
  endpoints.GET_INVOICE_BY_PROVIDER
);

export const getStoreProvidersConfigApi = getCreator(
  endpoints.GET_STORE_PROVIDERS
);

export const createStoreProvidersConfigApi = postCreator(
  endpoints.CREATE_STORE_PROVIDERS
);

export const getInvoiceTypesApi = getCreator(endpoints.GET_INVOICE_TYPES);

export const getOrderTaxInvoiceListApi = getCreator(
  endpoints.GET_ORDER_TAX_INVOICE_LIST
);

export const getOrderTaxInvoiceListByIdsApi = getCreator(
  endpoints.GET_ORDER_TAX_INVOICE_LIST_BY_IDS
);

export const getOrderTaxInvoiceInformationListByIdsApi = getCreator(
  endpoints.GET_ORDER_TAX_INVOICE_INFORMATION_LIST_BY_IDS
);

export const generateOrderTaxInvoiceApi = postCreator(
  endpoints.GENERATE_ORDER_TAX_INVOICE
);

export const getStoreTaxInvoiceTypeApi = getCreator(
  endpoints.GET_STORE_TAX_INVOICE_TYPE
);

export const getOrderTaxInvoiceInformationApi = getCreator(
  endpoints.GET_ORDER_TAX_INVOICE_INFORMATION
);

export const editOrderTaxInvoiceDataApi = putCreator(
  endpoints.EDIT_ORDER_TAX_INVOICE_DATA
);

export const cancelOrderTaxInvoiceApi = postCreator(
  endpoints.CANCEL_ORDER_TAX_INVOICE
);

export const getTaxInvoiceSettingApi = getCreator(
  endpoints.GET_TAX_INVOICE_SETTING
);
export const setTaxInvoiceSettingApi = postCreator(
  endpoints.SET_TAX_INVOICE_SETTING
);
